import './App.css';
import React from "react";


import {Route, Routes} from "react-router-dom";
import Login from "./pages/Login";
import Home from "./pages/Home";



function App() {

    // const [currentMonth,setCurrentMonth]=useState(getMonth());
    // const {monthIndex,showEventModal}= useContext(GlobalContext);
    // useEffect(()=>{
    //     setCurrentMonth(getMonth(monthIndex))
    // },[monthIndex])
    return (
        <div className = "bg-white">
            <Routes>
                {/* <Route path="/" element={<Welcome />} /> */}
                <Route path="/" element={<Login />} />
                <Route path="/home" element={<Home />} />
                {/*<Route path="/billing" element={<Billing />} />*/}
                {/*<Route path="/signin" element={<SignIn />} />*/}
            </Routes>



        </div>
    );
}

export default App;
